<template>
  <!-- Advance Search -->
  <div class="grid bg-white" v-if="advanceSearch">
    <div class="grid-title">
      <div class="row">
        <div class="col-md-6">
          <h4>Advance Search</h4>
        </div>
        <div class="col-md-6 text-right">
          <div
            class="btn btn-danger btn-sm"
            @click="$emit('update:advanceSearch', false)"
          >
            <i class="fa fa-close" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-body" v-if="advanceSearch">
      <table class="table">
        <tbody>
          <tr>
            <td colspan="3">
              <toggle-button
                v-model="serverParams.productionOnly"
                @change="$emit('toggle', true)"
              /><br />
              <span class="text-bold" v-if="serverParams.productionOnly"
                >Production Shirts Only</span
              >
              <span class="text-bold" v-else>All Shirts</span>
            </td>
          </tr>

          <tr v-for="search in searchTypes" :key="search.column">
            <td>
              {{ search.title }}
            </td>
            <td width="200px">
              <select class="form-control" v-model="search.option">
                <option
                  v-for="opt in options"
                  :key="opt.value"
                  :value="opt.value"
                >
                  {{ opt.name }}
                </option>
              </select>
            </td>
            <td>
              <v-select
                taggable
                multiple
                v-model="search.keyword"
                pushTags
                :closeOnSelect="false"
                :options="[]"
              />
            </td>
          </tr>

          <tr>
            <td colspan="3">
              <button class="btn btn-success" @click="$emit('submit', true)">
                <i class="fa fa-search" aria-hidden="true"></i> Search
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- Advance Search -->
</template>

<script>
export default {
  props: ["advanceSearch", "searchTypes", "options", "serverParams"],
};
</script>

<style scoped>
.search-type {
  height: 38px !important;
}
</style>
